<template>
    <div id="gameTask">
        <Headers :headersText='headersText'></Headers>
        
         <!-- 导航切换栏 -->
        <div class="switchColumn">
            <div class="cols" v-for="(items,indexs) in switchColumn" :key="indexs" :style="{color:(switchNum == indexs ? '#151515' : '#666666')}" @click="switchChoose(indexs)">
                {{items}}
                <span class="switchLine" v-if="switchNum == indexs"></span>
                <span class="switchLineNone" v-else></span>
            </div>
        </div>
    </div>
</template>

<script>
    import Headers from '../components/headers'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'游戏任务',
                switchColumn:['投放中','审核中','已完成'],
                switchNum:0,
            }
        },
        methods: {
            switchChoose:function(indexs){
                this.switchNum = indexs
            },
        },
    }
</script>

<style lang="less" scoped>
    #gameTask{
        // 导航切换栏
        .switchColumn{
            width:375px;
            height:44px;
            display: flex;
            .cols{
                width: 33.33%;
                font-size:16px;
                font-weight:600;
                line-height:16px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-end;
                .switchLine{
                    display: inline-block;
                    width:24px;
                    height:3px;
                    background:rgba(229,1,19,1);
                    border-radius:2px;
                    margin: 6px 0 5px;
                }
                .switchLineNone{
                    display: inline-block;
                    width:24px;
                    height:3px;
                    background:transparent;
                    border-radius:2px;
                    margin: 6px 0 5px;
                }
            }
        }
    }
</style>